import './HomePage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import LoadingSpinner from 'components/LoadingSpinner';

class HomePage extends React.Component {
    componentDidMount() {
        //this.props.changeLocation('/assignments');
    }

    render() {
        return <LoadingSpinner />
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js